import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MakeRequest } from "./DataUtil";
import { UserProps } from "./IComponents";
import {
  RemoveTokenFromLocalStorage,
  GetTokenFromLocalStorage,
} from "./Account/AuthenticationContext";
import { getStore, createStore, setStore } from "./Stores";
import Config from "../configData.json";

interface Props {
  path: string;
  isLogout?: boolean;
  params?: any;
}
export function Redirect(props: Readonly<Props>): any {
  const navigate = useNavigate();

  if (
    props.isLogout !== null &&
    props.isLogout !== undefined &&
    props.isLogout
  ) {
    RemoveTokenFromLocalStorage();
  }

  useEffect(() => {
    if (props.params) {
      navigate(props.path, {
        state: { order: props.params },
      });
    } else {
      navigate(props.path);
    }
  }, []);
  return <></>;
}

interface FormProps {
  element: HTMLFormElement;
}

export function getAllFormElements(props: FormProps): any {
  const result = Array.from(props.element.elements).filter((tag) =>
    ["select", "textarea", "input"].includes(tag.tagName.toLowerCase())
  );
  return result;
}

export function showValidationErrors(errors: any): void {
  //show notification
  errors.forEach((element: any) => {
    if (
      document.getElementById(element.fieldName) !== null &&
      document.getElementById(element.fieldName) !== undefined
    ) {
      let inputElement: HTMLInputElement = document.getElementById(
        element.fieldName
      ) as HTMLInputElement;
      if (!inputElement.classList.contains("form-control-required-field")) {
        inputElement.classList.add("form-control-required-field");
      }
    }
  });
}

export function resetValidationErrors(element: HTMLInputElement): void {
  //reset styles
  if (element.classList.contains("form-control-required-field")) {
    element.classList.remove("form-control-required-field");
  }
}

export function getUserCulture(callback: any): void {
  let userCulture: string = "en";
  function successCallback(result: any): void {
    if (result && result !== undefined) {
      userCulture = result.UserCulture;
      callback(userCulture);
    }
  }
  function errorCallback(error: Error): void {
    if (error) {
      callback(userCulture);
    }
  }
  getUserCultureAsync({
    url: "CommonService/GetUserCulture",
    userId: "",
    successCallback,
    errorCallback,
  });
}

export async function getUserCultureAsync(props: UserProps): Promise<any> {
  let requestProps = {
    url: props.url,
    method: "get",
    data: {},
    successCallback: props.successCallback,
    errorCallback: props.errorCallback,
  };
  await MakeRequest(requestProps);
}

export async function recaptcha(props: UserProps): Promise<any> {
  let requestProps = {
    url: props.url,
    method: "post",
    data: { postData: props.data },
    successCallback: props.successCallback,
    errorCallback: props.errorCallback,
  };
  await MakeRequest(requestProps);
}

export const getCustomStyles = (): any => {
  return {
    option: (base: any, state: any) => ({
      ...base,
      backgroundColor: state.isSelected ? "black" : "white",
      color: state.isSelected ? "white" : "black",
    }),
  };
};

const checkMaintenanceMode = (mcode: any): boolean => {
  if (mcode !== null && mcode !== undefined && mcode !== "") {
    let qs: string[] = mcode.split("=");
    if (
      qs[1] !== null &&
      qs[1] !== undefined &&
      qs[1] === Config.MAINTENANCE_BYPASS_CODE
    ) {
      //create developer store
      let devMode: any = getStore("DevMode");
      if (devMode === null || devMode === undefined) {
        createStore("DevMode");
        setStore({ devMode: true }, "DevMode");
      } else if (devMode.length === 0) {
        setStore({ devMode: true }, "DevMode");
      }
      return false;
    }
  } else if (Config.MAINTENANCE_MODE === "true") {
    return true;
  }
  return false;
};

export const maintenanceMode = (mcode: any): boolean => {
  //if we're logged in then return false
  let token = GetTokenFromLocalStorage();
  if (token !== null && token !== undefined) {
    return false;
  }
  //get the mainentance mode value from the config
  let maintenanceMode: boolean = checkMaintenanceMode(mcode);
  //are we running in devmode
  let devMode: boolean = false;
  let devStore: any = getStore("DevMode");
  if (devStore !== null && devStore !== undefined) {
    devMode = devStore.devMode;
  }
  if (maintenanceMode && devMode) {
    maintenanceMode = false;
  }
  return maintenanceMode;
};
